<ng-container *ngIf="appModeService.isApp(); else webWishlistView">
  <section class="app-wishlist-view">
    <header class="app-wishlist-header">
      <button type="button" class="icon-btn" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
      </button>
      <h1>WISHLIST</h1>
      <span class="header-spacer" aria-hidden="true"></span>
    </header>

    <section class="app-wishlist-content">
      <div class="wishlist-meta-row">
        <p>({{ itemCount }}) items</p>
        <div class="wishlist-actions-icons" aria-hidden="true">
          <i class="pi pi-filter"></i>
          <i class="pi pi-sort-alt"></i>
        </div>
      </div>

      <div class="app-wishlist-grid" *ngIf="products.length > 0; else emptyWishlist">
        <article
          class="app-wishlist-item"
          *ngFor="let item of products; trackBy: trackByProduct"
          (click)="viewProduct(item.id)"
        >
          <div class="product-wrapper h-100">
            <app-product-card [data]="item" [appMode]="true"></app-product-card>
          </div>
        </article>
      </div>

      <ng-template #emptyWishlist>
        <div class="empty-state">
          <p>Your wishlist is empty.</p>
        </div>
      </ng-template>

      <button
        type="button"
        class="show-more-btn"
        *ngIf="products.length > 0"
      >
        SHOW MORE
      </button>
    </section>
  </section>
</ng-container>

<ng-template #webWishlistView>
  <div class="container py-5">
    <h1 class="main-title">Wishlist</h1>
    <div class="app-wishlist-grid web-grid" *ngIf="products.length > 0; else webEmptyWishlist">
      <article
        class="app-wishlist-item"
        *ngFor="let item of products; trackBy: trackByProduct"
        (click)="viewProduct(item.id)"
      >
        <div class="product-wrapper h-100">
          <app-product-card [data]="item"></app-product-card>
        </div>
      </article>
    </div>
    <ng-template #webEmptyWishlist>
      <p>Your wishlist is empty.</p>
    </ng-template>
  </div>
</ng-template>
